/**
 * Pollo MiniMax Hailuo 2.3：input 结构单独封装
 * 图生：image 必填，prompt max 2000，promptOptimizer 默认 true，resolution 768P|1080P，length 6|10
 * 文生：prompt 必填 1-2000，resolution、length、promptOptimizer
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '768P', '480P': '768P', '720p': '768P', '720P': '768P', '768p': '768P', '768P': '768P', '1080p': '1080P', '1080P': '1080P' }

function normalizeResolution(v) {
  if (!v) return '768P'
  var key = String(v).trim()
  return RES_MAP[key] || '768P'
}

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 6
  return num === 10 ? 10 : 6
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2000),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    length: normalizeLength(params.videoDuration || params.length || 6)
  }
  if (hasImage) {
    input.image = params.referenceImage.trim()
    input.promptOptimizer = (params.promptEnhance !== false && params.promptOptimizer !== false)
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
